export default "__VITE_ASSET__dddfe633__"